import React from "react";

const WhyFyxme = () => {
    return (
        <section className="ls s-pt-55 s-pt-md-50 s-pb-50 s-pt-lg-100 s-pb-lg-50 service-section text-center text-lg-left c-gutter-0" id="service">
            <div className="container">
                <div className=" col-12 mb-50 text-center">
                    <h4>Why Fyxme?</h4>
                    <div className="divider-60 d-none d-xl-block"></div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6 col-xl-6">
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/Approved-Paint.png" alt="All insurance claims accepted"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Mercedes Approved Paint with Lifetime Guarantee
                                </h6>
                                <p>
                                    Our advanced computerized paint color matching and high-quality application system will ensure a perfect match with the Mercedes PPG Envirobase approved paint. 
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/11.png" alt="Save time and Money"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Save Time and Money
                                </h6>
                                <p>
                                    Don’t leave your car at a shop for days. We provide mobile bumper and body repair services at your home or office - 7 days a week, saving you time and money.

                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/06Replacement-Parts.png" alt="replacement parts"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Bumper and Fender Replacement
                                </h6>
                                <p>
                                    Mercedes Benz bumper replacements if required can be done on site. Most damaged bumpers can be repaired and painted but we do replacement too. 
                                </p>
                            </div>
                        </div>

                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/05Paint-Matching.png" alt="paint matchinh"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Lifetime Paint Warranty
                                </h6>
                                <p>
                                    Mercedes Benz paint repair jobs are certified with a lifetime warranty from the manufacturer.  We use PPG paint which has been approved for all Mercedes paint repairs. 
                                </p>
                            </div>
                        </div>

                        
                    </div>

                    <div className="col-lg-6 col-md-6 col-xl-6">
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/Experienced-Technicians.png" alt="All insurance claims accepted"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Experienced Mercedes Benz Techs 
                                </h6>
                                <p>
                                    Our technicians have a combined 20+ years repairing Mercedes bumpers and more. We have fixed all makes, models and colors.  We have experience.  
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/07Best-Quality.png" alt="best quality"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Dealership Quality
                                </h6>
                                <p>
                                    We have partnered with the industry’s best suppliers to ensure the tools and products we use achieve the same results you will find anywhere else.
                                </p>
                            </div>
                        </div>
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/12.png" alt="dent repair"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    Dent Repair
                                </h6>
                                <p>
                                    We repair dented hoods, door dings, and bumper and fender dents quickly and affordably, helping to restore your car back to its
                                    original condition.
                                </p>
                            </div>
                        </div>

                        
                        <div className="media">
                            <div className="icon-styled color-main fs-40">
                                <img src="images/icons/03No-rental-car.png" alt="All insurance claims accepted"/>
                            </div>
                            <div className="media-body">
                                <h6>
                                    All insurance claims accepted
                                </h6>
                                <p>
                                    We will come to you and if you need a ride to work we have partnered with UBER. 
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WhyFyxme;